<template>
    <div v-if="isCardTabLoaded" :class="$style.tabContainer">
        <Icons />

        <Header />

        <Activation :class="$style.activation" v-if="showPayButton && isCardTabLoaded && !widgetStatus.isActive"/>

        <div 
            v-if="widgetStatus.isActive && isFailLoadingSettings || widgetStatus.isActive && isfailLoadingOrganizations"
            :class="$style.errorLoadingData"
        >
            {{ errorLoading }}
        </div>

        <template v-if="isCardTabLoaded && widgetStatus.isActive && isEntityValid">
            <OrderInfo />
            <CreateDocument v-if="isOrderCreated" />
            <Documents />
        </template>

        <Alert v-else 
               type="error"
               title="Ошибка"
               :class="$style.authAlert"
        >
            <template v-slot:text>
                <div v-if="isCompany">
                    <span>Виджет не работает в карточке компании</span>
                </div>
                <div v-else-if="isContact">
                    <span>Виджет не работает в карточке контакта</span>
                </div>
                <div v-else>
                    <span>Неизвестная ошибка</span>
                </div>
            </template>
        </Alert>
    </div>
    <div v-else :class="$style.tabContainer">
        <Header />
        <Preload v-if="isAmoAuthorized"/>
        <Alert v-else
            type="error"
            title="Нет доступа к авторизации"
            :class="$style.authAlert"
        >
            <template v-slot:text>
                <div v-if="isAdmin">Для того, чтобы выдать доступы к авторизации необходимо перейти по
                    <a :href="`https://www.amocrm.ru/oauth?client_id=${partnerData.clientId}`" target="_blank">ссылке</a>
                </div>
                <div v-else>
                    <span>Для того, чтобы выдать доступы к авторизации необходимо перейти по </span>
                    <span :class="$style.disabledAuthLink">ссылке</span>
                    <span> (только для администраторов)</span>
                </div>
            </template>
        </Alert>
    </div>
</template>

<script>

import {mapGetters} from 'vuex';

import Icons from '@/gnzs-controls/IconsSprite';
import Preload from '@/components/Tab/TabPreload/TabPreload';
import OrderInfo from '@/components/Tab/OrderInfo/OrderInfo';
import CreateDocument from '@/components/Tab/CreateDocument/CreateDocument';
import Documents from '@/components/Tab/Documents/Documents';
import Activation from '@/components/Settings/Activation';
import Header from './header';
import Alert from '@/gnzs-controls/Alert';
import { GNZS_WIDGET_ID } from '@/store/constants';

export default {
    data(){
        return {
            errorLoading: 'Ошибка загрузки данных. Попробуйте позже еще раз',
        }
    },
    computed: {
        ...mapGetters({
            isCardTabLoaded: 'isCardTabLoaded',
            isOrderCreated: 'order/isCreated',
            widgetStatus: 'widgetStatus',
            partnerData: 'partnerData',
            isAdmin: 'isAdmin',
            isAmoAuthorized: 'isAmoAuthorized',
            isFailLoadingSettings: 'settings/failLoading',
            isfailLoadingOrganizations: 'organizations/failLoading',
            entity: 'order/entity',
            widgetId: 'widgetId'
        }),
        showPayButton(){
            return this.widgetId == GNZS_WIDGET_ID
        },
        isEntityValid(){
            return !this.isCompany && !this.isContact
        },
        isCompany(){
            return this.entity.entityType == 3
        },
        isContact(){
            return this.entity.entityType == 1
        },
    },
    components: {
        Icons,
        Preload,
        OrderInfo,
        CreateDocument,
        Documents,
        Activation,
        Header,
        Alert
    }
}
</script>


<style lang="scss" module>
    @import './style.scss';
</style>